export default "__VITE_ASSET__BOEH65CP__"